import { createAction, props } from '@ngrx/store';

export const LoadItineraryHistorySuccess = createAction(
  '[Itinerary History] Load Itinerary History Log Success',
  props<{ itineraryLogHistory: string }>()
);
